import util from '@utils/util';
export default {
  name: 'LiveVideoItem',
  props: {
    cover: String,
    heat: String,
    desc: String,
    nickname: String,
    link: String,
    vdoid: String,
    ldcC: String,
    ldcD: String,
    isSpa: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {
    // 获取url地址
    getLiveRoomLink: function getLiveRoomLink(vdoid) {
      util.KEWLSensorTrack({
        lmweb_clickText: '直播列表',
        lmweb_tabName: vdoid
      });
      console.log('大数据进入直播间上报--getLiveRoomLink');
      // 大数据进入直播间上报
      util.ldcTrack({
        act: 2,
        c: this.ldcC || '',
        d: this.ldcD
      });
      // 存储当前点击直播间大数据c值和可能正在播放的C
      if (window.localStorage) {
        window.localStorage.setItem('lastLdcC', window.localStorage.getItem('ldcC'));
        window.localStorage.setItem('lastLdcD', window.localStorage.getItem('ldcD'));
        window.localStorage.setItem('lastVid', window.localStorage.getItem('ldcVid'));
        window.localStorage.setItem('ldcC', this.ldcC);
        window.localStorage.setItem('ldcD', this.ldcD);
        window.localStorage.setItem('ldcVid', vdoid);
      }
      /**
       * 存储列表的图片 直播间优先展示
       */
      try {
        sessionStorage.setItem('GET_LIST_IMG', this.getCover());
      } catch (err) {
        // 在这里处理错误
        console.error('GET_LIST_IMG', err);
      }
      var local = util.getI18nLocale();
      var json = {
        pathname: "/".concat(local, "/v/").concat(vdoid, "/index.html"),
        spa: "/".concat(local, "/").concat(vdoid, "/live.html"),
        search: {}
      };
      if (util.isSpa()) {
        util.loadingFunc({
          time: 2000
        });
        util.KEWLSensorTrack({
          lmweb_clickText: '进入spa直播间'
        });
        this.$lmBus && this.$lmBus.$emit('goTo', {
          path: json.spa
        });
      } else {
        util.loadingFunc({
          time: 2000
        });
        window.location.href = util.directToPath(json);
      }
      return false;
    },
    getCover: function getCover() {
      return util.forceHttps(this.cover);
    },
    getTarget: function getTarget() {
      var target = '_blank';
      if (util.isMobile()) {
        target = '_self';
      }
      return target;
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
};